/* eslint-disable */
import store from '@/store';
import { isHighChartsReady } from '@/utils/helpers';


export const waitForFirebaseInitialized = () => {
  return new Promise((resolve) => {
    const check = () => {
      if (store.state.app.firebaseInitialized) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};


export const waitForStatusReady = () => {
  return new Promise((resolve) => {
    const check = () => {
      if (typeof store.state.user.status.hasBeenFunded !== 'undefined') {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

export const waitForSignalrInitialized = () => {
  return new Promise((resolve) => {
    const check = () => {
      if (store.state.app.signalrInitialized || !store.getters['user/isLoggedIn']) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};


export const waitForHighCharts = () => {
  return new Promise((resolve) => {
    const check = () => {
      if (isHighChartsReady()) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
}



// WEBPACK FOOTER //
// ./src/utils/mutex.js